import { render, staticRenderFns } from "./gangchan.vue?vue&type=template&id=10b1c194&scoped=true"
import script from "./gangchan.vue?vue&type=script&lang=js"
export * from "./gangchan.vue?vue&type=script&lang=js"
import style0 from "./gangchan.vue?vue&type=style&index=0&id=10b1c194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b1c194",
  null
  
)

export default component.exports